<template>
<div class="flex-fill fill flex column ofy">

<div class="opt r">
    <i title="Opciones" class="options icon-dots-vertical ml5" v-show="tab == 'Pendientes'" @click="Options([
        { text: 'Exportar', function: () => ExportPendingPayments(), icon: 'download' },
    ])"></i>
    <input-date :icon="mobile ? 'calendar' : null" 
        slot="options"
        v-show="tab == 'Historial'"
        inputClass="secondary" 
        type="DATE"
        format="timestamp"
        v-model="dateFilter"
        modalOnly
        :toEndDay="true"
        @OnAcceptDate="Bottom()">
    </input-date>
</div>
<tabs v-if="tabs" :tabs="tabs" :keyByTab="true" v-model="tab" 
    @OnTabHistorial="!historial.length ? Bottom() : null">

    <div slot="Pendientes" class="pa-body">
        <div class="mb20" v-if="canPayTransactions">
            <div class="f18 mb20">Transacciones</div>
            <div class="secondary-text ta-center mt10" v-if="!pendingPayments.length">No hay pagos pendientes</div>
            <div :class="`section mb10 selectable`"
            v-for="(pendingPayment, index) in pendingPayments"
            :key="index"
            @click="ViewTransactions(pendingPayment)">
                <div class="flex fill align-center">
                    <div class="flex column flex-fill">
                        <div class="flex" :class="{'column' : mobile}"> <span class="bold">{{pendingPayment.data}}</span> <div class="secondary-text " :class="{'ml5' : !mobile}" v-if="pendingPayment.pending_transaction"><span class="cred">Saldo pendiente</span></div></div>
                        <div class="secondary-text"><span class="bold">Transacciones: </span>{{Util.Number(pendingPayment.transactions.length)}}</div>
                        <div class="secondary-text" v-if="pendingPayment.pending_transaction"><span class="bold">Abonos: </span>{{Util.Number(pendingPayment.pending_transaction.length)}}</div>
                        <div class="secondary-text"><span class="bold">Rango: </span>{{Util.Date(pendingPayment.first_transaction, mobile?'L':'LL')}} - {{Util.Date(pendingPayment.last_transaction, mobile?'L':'LL')}}</div>
                    </div>
                    <div class="flex" :class="{'column' : mobile}">
                        <span class="mr5 line-through cred" v-if="pendingPayment.pending_transaction">{{Util.Price(pendingPayment.total_money)}}</span>
						<span>{{ pendingPayment.pending_transaction ? Util.Price(pendingPayment.total_money-PendingPaymentTotal(pendingPayment.pending_transaction)) : Util.Price(pendingPayment.total_money)}}</span>
                        
                    </div> 
                    <div class="options icon-dots-vertical ml10" @click.stop="Options([
                        {text: 'Imprimir', function: () => {Print(pendingPayment)}, if: !!Local.modules.module_service, icon: 'printing'},
                        {text: 'Imprimir Todas', function: () => {PrintAll(pendingPayment)}, confirm: `Se imprimiran ${pendingPayment.transactions.length} voucher. ¿Desea continuar?`, if: !!Local.modules.print_customer, icon: 'printing'},
                        {text: 'Liquidar Pago Pendiente', class: 'selected-color', function: () => OpenModalPendingPayment(pendingPayment), icon: 'hourglass-check'},
                    ])"></div>
                </div>
            </div>
            
        </div>

        <div class="" v-if="canPayInvoices">
            <div class="f18 mb20 flex align-center">Facturas de Proveedor <span class="counter">{{pendingInvoices.length}}</span></div>
            <div class="secondary-text ta-center mt10" v-if="!pendingInvoices.length">No hay facturas pendientes</div>
            <div v-else>
                <div :class="`section selectable mb10`"
                v-for="invoice in pendingInvoices"
                :key="invoice.id"
                @click="$refs.invoiceDetails.Open(invoice, false, 'pendingPayments')">
                    <div class="flex fill align-center">
                        <div class="flex column flex-fill">
                            <div class="bold">{{invoice.is_invoice ? 'Factura' : 'Boleta'}} de {{ invoice.type == 'FACTURA_EXPENSES' ? 'Gastos' : 'Inventario' }} N°{{invoice.number}}</div>
                            <div class="secondary-text"><span class="bold">Proveedor: </span>{{invoice.custom_data.provider.name}} <span v-if="invoice.custom_data.provider.rut && (invoice.custom_data.provider.has_rut == undefined || invoice.custom_data.provider.has_rut)">- {{ invoice.custom_data.provider.rut }}</span></div>
                            <div class="secondary-text"><span class="bold">Ingresado: </span>{{Util.Date(invoice.created_at)}}</div>
                        </div>
                        <div class="bold">{{Util.Price(invoice.total)}}</div>
                    </div>
                </div>
            </div>

            <div class="f18 mt20 mb20 flex align-center">Boletas de Proveedor <span class="counter">{{peningNotInvoices.length}}</span></div>
            <div class="secondary-text ta-center mt10" v-if="!peningNotInvoices.length">No hay boletas pendientes</div>
            <div v-else>
                <div :class="`section selectable mb10`"
                v-for="invoice in peningNotInvoices"
                :key="invoice.id"
                @click="$refs.invoiceDetails.Open(invoice, false,'pendingPayments')">
                    <div class="flex fill align-center">
                        <div class="flex column flex-fill">
                            <div class="bold">{{invoice.is_invoice ? 'Factura' : 'Boleta'}} de {{ invoice.type == 'FACTURA_EXPENSES' ? 'Gastos' : 'Inventario' }} N°{{invoice.number}}</div>
                            <div class="secondary-text"><span class="bold">Proveedor: </span>{{invoice.custom_data.provider.name}} <span v-if="invoice.custom_data.provider.rut && (invoice.custom_data.provider.has_rut == undefined || invoice.custom_data.provider.has_rut)">- {{ invoice.custom_data.provider.rut }}</span></div>
                            <div class="secondary-text"><span class="bold">Ingresado: </span>{{Util.Date(invoice.created_at)}}</div>
                        </div>
                        <div class="bold">{{Util.Price(invoice.total)}}</div>
                    </div>
                </div>
            </div>

        </div>

    </div>

    <vertical-content ref="verticalHistory" slot="Historial" class="pa-body" @OnBottom="Bottom(true)">
        <div class="secondary-text ta-center mt10" v-if="!historial.length">No hay datos.</div>
        <div class="" v-else>
            <div class="section mb10 selectable"
            v-for="(receipt, index) in historial"
            :key="index"
            @click="HistoryClick(receipt)">
                <div class="flex fill align-center">
                    <div class="flex column flex-fill">
                        <div class="bold">{{receipt.method}}</div>
                        <div class="secondary-text"><span class="bold">Fecha: </span>{{Util.Date(receipt.date)}}</div>
                        <div class="secondary-text" v-if="receipt.type=='TRANSACTIONS'"><span class="bold">Transacciones: </span>{{Util.Number(receipt.transactions.length)}}</div>
                        <div class="secondary-text"><span class="bold">Método de Pago: </span>{{Util.PayMethod(receipt.pay_method)}}</div>
                    </div>
                    <div>
                        <div v-if="receipt.custom_data.partial_payment" class="bold ta-center">Abono</div>
						<span>{{ receipt.custom_data.partial_payment ? Util.Price(receipt.custom_data.partial_payment) : Util.Price(receipt.total_money)}}</span>
                    </div>
                    <div v-if="receipt.type == 'TRANSACTIONS'" class="options icon-dots-vertical ml10" @click.stop="Options([
                        {text: 'Imprimir', function: () => {Print(receipt)}, if: !!Local.modules.module_service, icon: 'printing'},
                        {text: 'Imprimir Todas', function: () => {PrintAll(receipt)}, confirm: `Se imprimiran ${receipt.transactions.length} voucher. ¿Desea continuar?`, if: !!Local.modules.module_service, icon: 'printing'},
                        {text: 'Ver Transacciones', function: () => {TransactionsList(receipt.transactions)}, icon: 'check-list'},
                    ])"></div>
                </div>
            </div>
        </div>
    </vertical-content>

</tabs>

<modal v-model="modalPayPendingPayment" dir="center" :modalClass="'sm'" :title="modalPayPendingPayment ? modalPayPendingPayment.data : ''">
    <div v-if="modalPayPendingPayment">
        <div class="section">
            <div class="mb15">
                <div class="bold">Transacciones</div>
                <div>{{Util.Number(modalPayPendingPayment.transactions.length)}}</div>
            </div>
            <div class="mb15" v-if="modalPayPendingPayment.pending_transaction">
                <div class="bold">Abonos</div>
                <div>
                    {{Util.Number(modalPayPendingPayment.pending_transaction.length)}}
                </div>
            </div>
            <div class="mb15 hs">
                <div>
                    <div class="bold">Total a Pagar</div>
                    <span class="line-through cred" v-if="modalPayPendingPayment.pending_transaction">{{Util.Price(modalPayPendingPayment.total_money)}}</span>
                    <span v-else>{{ modalPayPendingPayment.pending_transaction ? Util.Price(modalPayPendingPayment.total_money-PendingPaymentTotal(modalPayPendingPayment.pending_transaction)) : Util.Price(modalPayPendingPayment.total_money)}}</span>
                </div>
                <div v-if="modalPayPendingPayment.pending_transaction">
                    <div class="bold">Pendiente a Pagar</div>
                    <span>{{ modalPayPendingPayment.pending_transaction ? Util.Price(modalPayPendingPayment.total_money-PendingPaymentTotal(modalPayPendingPayment.pending_transaction)) : Util.Price(modalPayPendingPayment.total_money)}}</span>
                </div>
            </div>

            <label class="mb10 restriction-option">
                <input :disabled="modalPayPendingPayment.enable_partial_payment && modalPayPendingPayment.pending_transaction && modalPayPendingPayment.pending_transaction.length > 0" type="checkbox" v-model="modalPayPendingPayment.enable_partial_payment"> Pago parcial<div class="checkmark"></div>
            </label>
            <div class="mb15" v-if="modalPayPendingPayment.enable_partial_payment">
                <div >
                    <input-field
                    type="int+"
                    prefix="$"
                    cleareable
                    ref="partialPayment"
                    v-model="modalPayPendingPayment.partial_payment"
                    >
                    <button slot="after" @click="modalPayPendingPayment.partial_payment = (modalPayPendingPayment.total_money-PendingPaymentTotal(modalPayPendingPayment.pending_transaction))" class="secondary border bl0">Ingresar Pendiente</button>
                    </input-field>
                </div>
                <div class="mt10" >
                    <div class="bold">Pendiente Restante </div>
                    <div :class="modalPayPendingPayment.total_pending_payment <0 ? 'cred':null">{{Util.Price(modalPayPendingPayment.total_pending_payment)}}</div>
                </div>
            </div>

            <input-select
            label="Método de pago"
            v-model="modalPayPendingPayment.method"
            :items="possiblePayMethods"
            canType="search">
            </input-select>
        </div>

    </div>
    
    <button slot="actions" class="primary purple" @click="PayPendingPayment()">Liquidar Pago Pendiente</button>
    
</modal>

<modal v-model="modalViewPendingData" dir="right" :title="'Detalle transacción'" :modalClass="['fill', 'sm right h100']" hideActions>
    <tabs v-if="modalViewPendingData" :tabs="['Transacciones', 'Abonos']" :keyByTab="true" v-model="tabModal">
        <vertical-content ref="Transactions" slot="Transacciones" class="pa20" >
            <div class="" v-if="modalViewPendingData.transactions.length > 0">
                <div class="entry selectable" 
                v-for="(transaction, index) in modalViewPendingData.transactions"
                :key="index"
                @click="$refs.details.Open(transaction)">
                    <div class="flex fill align-center">
                        <div class="flex-fill flex column">
                            <div class="bold">#{{Util.Zeropad(transaction.id_ticket, 10)}}</div>
                                <div class="secondary-text"><span class="bold">Fecha: </span>{{Util.Date(transaction.created_at, 'DD/MM/YYYY HH:mm')}}</div>
                                <div class="secondary-text"><span class="bold">Método de Pago: </span><span v-for="(payment, index2) in transaction.payment" :key="index2">{{Util.PayMethod(payment.method)}} </span></div>
                                <div class="secondary-text">Para {{Util.SaleType[transaction.type]}} <span v-if="transaction.customer.name">a {{transaction.customer.name}} <i v-if="transaction.id_user" style="color: rgb(0, 151, 255)" class="icon icon-corbatin"></i></span></div>
                        </div>
                        <div class="bold">{{Util.Price(transaction.total_money)}}</div>
                    </div>
                </div>
            </div>
            <div v-else class="secondary-text mt10 ta-center">No hay transacciones.</div>
        </vertical-content>
        <vertical-content ref="pending" slot="Abonos" class="pa20" >
            <div class="" v-if="modalViewPendingData.pending_transactions.length > 0">
                <div class="entry " 
                v-for="(pending, index) in modalViewPendingData.pending_transactions"
                :key="index">
                    <div class="flex fill align-center">
                        <div class="flex-fill flex column">
                            <div >
                                <div>Abono</div>
                                <div class="bold">
                                    {{Util.Price(pending.custom_data.partial_payment)}}
                                </div> 
                            </div>
                            <div class="secondary-text"><span class="bold">Fecha: </span>{{Util.Date(pending.date, 'DD/MM/YYYY HH:mm')}}</div>
                            <div class="secondary-text" v-if="pending.pay_method"><span class="bold">Método de pago:</span> {{Util.PayMethod(pending.pay_method)}}</div>
                        </div>
                        
                    </div>
                </div>
            </div>
            <div v-else class="secondary-text mt10 ta-center">No hay abonos.</div>
        </vertical-content>
    </tabs>
</modal>


<transactions-list ref="transactionsList"></transactions-list>
<transaction-details ref="details" @OnTransactionDeleted="DeleteTransaction()"></transaction-details>
<invoice-details ref="invoiceDetails" @OnInvoicePaid="UpdatePendingInvoices" @OnInvoiceDeleted="UpdatePendingInvoices" @OnInvoiceUpdated="Reset"></invoice-details>
<pending-payment-details ref="pendingPaymentDetails"></pending-payment-details>
</div>
</template>

<script>
export default {
    data() {
        return {
            pendingPayments: [],
            modalPayPendingPayment: null,
            dateFilter: null,
            historial: [],
            historialDate: null,
            acceptsCash: true,
            payMethods: [],
            tabs: null,
            tab: null,
            pendingInvoices: [],
            peningNotInvoices : [],
            searchFactura: null,
            modalViewPendingData : null,
            tabModal: null
        }
    },
    mounted() {

        this.tabs = [];
        this.tabs.push('Pendientes');
        if(this.isAdmin) this.tabs.push('Historial');

        this.$nextTick(() => {
            this.Reset();
        });
        this.$root.$on('PendingPaymentPaid', this.Reset);
    },
    methods: {

        Reset(pendingMethod) {
            this.$root.$emit('Loading');
            axios.get(`/payments/pending/${this.Local.id}?v2=true`).then(res => {
                this.$root.$emit('Response', res);
                this.pendingPayments = res.data.pending;
                this.pendingInvoices = res.data.invoices;
                this.peningNotInvoices = res.data.notInvoices;
                this.payMethods = res.data.methods;
                this.acceptCash = res.data.accept_cash;
                var moment = require('moment');
                this.historialDate = moment().unix();
            }).catch(err => {
                this.$root.$emit('Response', err);
            });
            this.historial = [];
            this.modalPayPendingPayment = null;
            this.$refs.transactionsList.Close();
            if(pendingMethod) {
                if(this.$refs.details) this.$refs.details.Close();
                let find = this.pendingPayments.find(element => element.data == pendingMethod);
                if(find) this.ViewTransactions(find);
            }
        },
        ExportPendingPayments(){
            this.Loading();
            axios.get(`/payments/pending/${this.Local.id}/export_pending`, {responseType : 'blob'}).then(res => {
                this.Response(res);
                this.Util.DownloadFile(res, `pagos_pendientes_${Util.Today().date.replace(/\//g, '-')}.xls`);
            }).catch(err => {
                this.Response(err);
            });   
        },
        ViewTransactions(pendingPayment)
        {
            
            this.Loading();
            axios.post(`/payments/pending/${this.Local.id}`, { transactions : pendingPayment.transactions.map(element => element.id)}).then(res => {
                this.Response(res);
                this.modalViewPendingData = { transactions : res.data, pending_transactions : []}
                if(pendingPayment.pending_transaction) this.modalViewPendingData.pending_transactions = pendingPayment.pending_transaction
            }).catch(err => {
                this.Response(err);
            });
        },
        PayPendingPayment() {
            this.$root.$emit('Loading');
            if(this.modalPayPendingPayment.enable_partial_payment && this.modalPayPendingPayment.partial_payment == 0) return this.Info("El valor del pago parcial debe ser mayor a 1.")
            if(this.modalPayPendingPayment.enable_partial_payment && (this.modalPayPendingPayment.total_pending_payment < 0)) return this.Info("El valor del pago parcial es mayor al total pendiente")
            var data = {
                pending_payment: this.modalPayPendingPayment.data,
                method: this.modalPayPendingPayment.method,
                enabled_partial_payment : this.modalPayPendingPayment.enable_partial_payment,
                partial_payment : this.modalPayPendingPayment.enable_partial_payment ? this.modalPayPendingPayment.partial_payment : 0 ,
                total_pending_payment : this.modalPayPendingPayment.enable_partial_payment ? this.modalPayPendingPayment.total_pending_payment : 0,
                transactions_used : this.modalPayPendingPayment.transactions.map(element => element.id),
            };

            axios.put(`/payments/pending/${this.Local.id}`, data).then(res => {
                this.$root.$emit('Response', {info: `${this.modalPayPendingPayment.data} pagado exitósamente.`});
                this.pendingPayments = this.pendingPayments.filter((v,i,a) => {
                    return v.data !== this.modalPayPendingPayment.data;
                });
                this.modalPayPendingPayment = null;
                this.Print(res.data);
                this.Reset();
            }).catch(err => {
                this.$root.$emit('Response', err);
            });
        },
        Bottom(bottom=false) {
            this.$root.$emit('Loading');
            this.$refs.verticalHistory.Reset()
            if(!bottom) this.historial = []
            this.$nextTick(() => {
                axios.get(`/payments/pending/${this.Local.id}/paid/${!bottom ? this.dateFilter : this.historialDate}`).then(res => {
                    this.historial = this.historial.concat(res.data);
                    this.historialDate = res.data[res.data.length-1].date;
                    this.$root.$emit('Response', res);
                }).catch(err => {
                    this.$root.$emit('Response', err);
                });
            })
        },
        TransactionsList(list)
        {
            var ids = [];
            for(var i = 0; i < list.length; i++)
                ids.push(list[i].id)
            this.$refs.transactionsList.Open(ids);
        },
        Print(data) 
        {
            var first = Math.min(data.transactions[0].created_at, data.transactions[data.transactions.length-1].created_at);
            var last = Math.max(data.transactions[0].created_at, data.transactions[data.transactions.length-1].created_at);

            var moment = require('moment');
            var arr = [
                {text: this.Local.name, align: 'CT', width: 2, height: 2},
                {text: 'Item: ' + (data.data ? data.data : data.method)},
                {text: 'Fecha: ' + moment().format('HH:mm DD/MM/YYYY')},
                {text: 'Estado: ' + (data.date ? `PAGADO EL ${this.Util.Date(data.date, 'HH:mm DD/MM/YYYY')}` : 'PENDIENTE')},
                {line: true},
                {text: 'Transacciones: ' + data.transactions.length},
                {text: 'Primera: ' + moment.unix(first).format('HH:mm DD/MM/YYYY')},
                {text: 'Ultima: ' + moment.unix(last).format('HH:mm DD/MM/YYYY')},
                {line: true},
            ];

            for(var i = 0; i < data.transactions.length; i++)
                arr.push({text: [`#${this.Util.Zeropad(data.transactions[i].id_ticket, 10)}`, this.Util.Number(data.transactions[i].total_money)]});

            if(!data.pending_transaction) arr.push({line: true});
                arr.push({text: ['Total', this.Util.Number(data.total_money)]});

            if(data.pending_transaction){
                arr.push({line: true});
                arr.push({text: 'Abonos: ' + data.pending_transaction.length},);
                let total_pendings = 0
                for(var i = 0; i < data.pending_transaction.length; i++){
                    total_pendings += data.pending_transaction[i].custom_data.partial_payment
                    arr.push({text: Util.PayMethod(data.pending_transaction[i].pay_method)+': $' + this.Util.Number(data.pending_transaction[i].custom_data.partial_payment)},);
                }

                
                arr.push({text: ['Total abono: $', this.Util.Number(total_pendings)]});
                arr.push({line: true});
                arr.push({text: ['Total pendiente: $', this.Util.Number(data.total_money - total_pendings)]});
            }

            this.Util.NotifyService('print', {data: arr, id: Math.random().toString()});

        },
        PrintAll(data)
        {
            var ids = [];
            for(var i = 0; i < data.transactions.length; i++)
                ids.push(data.transactions[i].id);

            this.Loading();
            axios.post(`/transactions/${this.Local.id}`, {ids: ids}).then(res => {
                this.Response(res);
                for(var i = 0; i < res.data.length; i++)
                {
                    this.Util.PrintTransaction(res.data[i], 'DEFAULT');
                }
            }).catch(err => {
                this.Response(err);
            });
        },
        HistoryClick(receipt)
        {
            if(receipt.type == 'INVENTORY_INVOICE' || receipt.type == 'EXPENSES_INVOICE') return this.$refs.invoiceDetails.Open(receipt.custom_data.id_invoice);
            if(receipt.type == 'TRANSACTIONS') return this.$refs.pendingPaymentDetails.Open(receipt);
        },
        UpdatePendingInvoices(invoice)
        {
            for(var i = 0; i < this.pendingInvoices.length; i++)
            {
                if(this.pendingInvoices[i].id == invoice.id)
                {
                    this.pendingInvoices.splice(i, 1);
                    return;
                }
            }
        },
        DeleteTransaction() {
            this.modalViewPendingData = null
            this.Reset()
        },
        PendingPaymentTotal(pending_transactions) {
            let total = 0
            if(!pending_transactions) return total

            pending_transactions.forEach(element => {3
                total += element.custom_data.partial_payment
                
            });
            return total
        },
        OpenModalPendingPayment(pending_payment){
            this.modalPayPendingPayment = pending_payment;
            this.$set(this.modalPayPendingPayment, 'enable_partial_payment', false);
            this.$set(this.modalPayPendingPayment, 'partial_payment', 0);
            let total = this.modalPayPendingPayment.total_money - this.PendingPaymentTotal(this.modalPayPendingPayment.pending_transaction)
            this.$set(this.modalPayPendingPayment, 'total_pending_payment', total);
            if(pending_payment.pending_transaction) this.modalPayPendingPayment.enable_partial_payment = true
        },
    },
    computed: {
        possiblePayMethods() {
            let ret = [];
            for(var i = 0; i < this.payMethods.length; i++)
            {
                ret.push({text: this.Util.PayMethod(this.payMethods[i]), value: this.payMethods[i]});
            }
            return ret;
        },
        canPayTransactions() {
            return !!(this.isAdmin || this.Auth.restrictions.pay_pending_payments);
        },
        canPayInvoices() {
			return !!(this.isAdmin || this.Auth.restrictions.pay_pending_inventory_invoices);
		},
    },
    beforeDestroy() {
        this.$root.$off('PendingPaymentPaid', this.Reset);
    },
    watch: {
        modalPayPendingPayment: {
            handler(n, o) {
                if (n) {
                    if(n.partial_payment == '') this.modalPayPendingPayment.partial_payment = 0;
                    if(!n.partial_payment) return this.modalPayPendingPayment.total_pending_payment = this.modalPayPendingPayment.total_money - this.PendingPaymentTotal(this.modalPayPendingPayment.pending_transaction);
                    // Calculamos el total del pago pendiente
                    this.modalPayPendingPayment.total_pending_payment = (this.modalPayPendingPayment.total_money - this.PendingPaymentTotal(this.modalPayPendingPayment.pending_transaction)) - n.partial_payment;
                }
            },
            deep: true
        }
    }

}
</script>

<style>

</style>
